import useModuleTranslation from "../infra-no-ui/translation/useModuleTranslation.js";
import React from "react";

/**
 * Dynamically load translation files pertaining to the candidates module.
 * @return {*}
 */
export default function useTranslationCandidates() {

  // Imports must be memoized so that they don't change on every render
  const imports = React.useMemo(() => ({
    'en': import('./locales/en/candidates.json'),
    'fr': import('./locales/fr/candidates.json')
  }), []);

  return useModuleTranslation('candidates', imports);
}
